import Resizer from "react-image-file-resizer";

export const resizeFile = ({ file, size, quality = 85 }) =>
    new Promise((resolve) => {
        if(file.type.indexOf("image/svg") >= 0){
            return resolve(file);
        }

        Resizer.imageFileResizer(
            file,
            size,
            size,
            file.type === "image/png" ? "PNG" : "JPEG",
            quality,
            0,
            (uri) => {
                resolve(dataURItoFile(uri, file.name));
            },
            "base64"
        );
    });

/**
 * Convert data
 * @param {*} dataurl
 * @param {*} filename
 */
const dataURItoFile = (dataURI, fileName) => {
    let arr = dataURI.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
};
